module.exports = __webpack_public_path__ + "static/media/door-open.9568c488.svg";